export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export interface FetchOptions {
  url: string;
  method: HttpMethod;
  body?: Record<string, string>;
  queryParameters?: Record<string, string>;
}

export enum Projection {
  BASIC = 'basic',
  FULL = 'full',
}
